import { registerDecorator } from 'class-validator';
import { z } from 'zod';
// https://regex101.com/r/U2o2dW/1
const symbolRegex = /[^A-Za-z0-9 ]/gi;
// https://regex101.com/r/u88IfK/1
const numberRegex = /[0-9]/gi;
// TODO: we really should just enourage creating memorable passwords
// with a minimum length of 12-20 characters, and not require symbols or numbers
// https://www.wired.com/2016/03/want-safer-passwords-dont-change-often/
// above article is not that good but it does link to this:
// https://www.baekdal.com/thoughts/password-security-usability
// > It is 10 times more secure to use "this is fun" as your password, than "J4fS<2".
export const passwordValidator = z
    .string({
    error: (issue) => issue.input === undefined
        ? 'password is required'
        : 'password must be a string',
})
    .min(8, { message: 'password must be at least 8 characters' })
    .refine((str) => Number(str.match(numberRegex)?.length) >= 1, {
    message: 'password must contain at least 1 digit',
})
    .refine((str) => Number(str.match(symbolRegex)?.length) >= 1, {
    message: 'password must contain at least 1 symbol',
});
export function IsPassword(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'IsPassword',
            target: object.constructor,
            propertyName: propertyName,
            options: {
                ...validationOptions,
                message: validationOptions?.message ??
                    'Password must be at least 8 characters, contain at least 1 digit, and contain at least 1 symbol',
            },
            validator: {
                async validate(value) {
                    try {
                        await passwordValidator.parseAsync(value);
                        return true;
                    }
                    catch {
                        return false;
                    }
                },
            },
        });
    };
}
//# sourceMappingURL=passwordValidator.js.map